import {
	Navbar as HeroUINavbar,
	NavbarContent,
	NavbarMenu,
	NavbarMenuToggle,
	NavbarBrand,
	NavbarItem,
	NavbarMenuItem,
} from "@heroui/navbar";
import { Button } from "@heroui/button";
import { Link } from "@heroui/link";
import { link as linkStyles } from "@heroui/theme";
import clsx from "clsx";

import { FaVoteYea } from "react-icons/fa";
import { NavLink } from "@remix-run/react";

import { siteConfig } from "config/site";
import { useEffect, useState } from "react";
import { FullLogo, Logo } from "./logo";
import { FaSquareXTwitter } from "react-icons/fa6";

export const Navbar = () => {
	const [isClient, setIsClient] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	if (!isClient) {
		return <></>;
	}

	return (
		<HeroUINavbar
			isMenuOpen={isMenuOpen}
			onMenuOpenChange={setIsMenuOpen}
			maxWidth="2xl"
			position="sticky"
			className="bg-gradient-to-t from-[#0F1119]/80 to-[#20183E]/80"
		>
			<NavbarContent className="basis-1/5 sm:basis-full" justify="start">
				<NavbarBrand as="li" className="gap-3 max-w-fit">
					<Link
						as={NavLink}
						className="flex justify-start items-center gap-1 text-default-900"
						to="/"
					>
						<Logo size={72} />
					</Link>
				</NavbarBrand>
				<ul className="hidden lg:flex gap-8 justify-start ml-2 font-bold">
					{siteConfig.navItems.map((item) => (
						<NavbarItem key={item.href}>
							<NavLink
								className={({ isActive }) =>
									isActive
										? clsx(linkStyles({ color: "warning" }))
										: clsx(linkStyles({ color: "foreground" }))
								}
								color="foreground"
								to={item.href}
							>
								{item.label}
							</NavLink>
						</NavbarItem>
					))}
				</ul>
			</NavbarContent>

			<NavbarContent
				className="hidden sm:flex basis-1/5 sm:basis-full"
				justify="center"
			>
				<NavbarBrand as="li" className="gap-3 max-w-fit">
					<Link
						as={NavLink}
						className="flex justify-start items-center gap-1 text-warning"
						to="/"
					>
						<FullLogo size={200} />
					</Link>
				</NavbarBrand>
			</NavbarContent>

			<NavbarContent
				className="hidden sm:flex basis-1/5 sm:basis-full gap-8"
				justify="end"
			>
				<NavbarItem className="hidden sm:flex gap-2">
					<Link
						as={NavLink}
						isExternal
						aria-label="Twitter"
						to={siteConfig.links.twitter}
					>
						<FaSquareXTwitter size={20} className="text-default-900" />
					</Link>
				</NavbarItem>

				<NavbarItem className="hidden md:flex">
					<Button
						as={Link}
						className="font-extrabold"
						href={siteConfig.links.vote}
						startContent={<FaVoteYea />}
						variant="ghost"
						color="warning"
					>
						Votar Ahora
					</Button>
				</NavbarItem>
			</NavbarContent>

			<NavbarContent className="sm:hidden basis-1 pl-4" justify="end">
				<NavbarMenuToggle />
			</NavbarContent>

			<NavbarMenu>
				<div className="mx-4 mt-2 flex flex-col gap-2">
					<Link as={NavLink} className=" text-[#ffe49cff]" to="/">
						<FullLogo size={130} />
					</Link>
					{siteConfig.navMenuItems.map((item, index) => (
						<NavbarMenuItem key={item.href}>
							<Link
								as={NavLink}
								color={
									index === 2
										? "primary"
										: index === siteConfig.navMenuItems.length - 1
											? "warning"
											: "foreground"
								}
								to={item.href}
								onPress={() => setIsMenuOpen(false)}
								size="lg"
							>
								{item.label}
							</Link>
						</NavbarMenuItem>
					))}
					<NavbarMenuItem className="mt-10">
						<Button
							as={Link}
							className="font-extrabold"
							href={siteConfig.links.vote}
							startContent={<FaVoteYea />}
							variant="ghost"
							color="warning"
						>
							Votar Ahora
						</Button>
					</NavbarMenuItem>
				</div>
			</NavbarMenu>
		</HeroUINavbar>
	);
};
